export const RIDER_MISCONDUCT_ENDPOINT = 'admin/rider_misconduct_ai_config';

export const PROMPT_MAX_LENGTH = 15000;

export const SKELETON_ROWS = [
  { cols: 1, height: '2.4rem', width: '200px' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 1, height: '3.6rem', width: '130px' },
];
